import {$api} from "./index";

export const createFile = async (file) => {
    const {data} = await $api.post('api/files', file)
    return data
}

export const fetchFiles = async () => {
    const {data} = await $api.get('api/files')
    return data
}

export const downloadFile = async (file) => {
    const response = await fetch(`${process.env.REACT_APP_API_URL}api/files/download?taskId=${file.taskId}&id=${file.id}`, {
        headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`
        }
    })
    if (response.status === 200) {
        const blob = await response.blob()
        const downloadUrl = window.URL.createObjectURL(blob)
        const link = document.createElement('a')
        link.href = downloadUrl
        link.download = file.name
        document.body.appendChild(link)
        link.click()
        link.remove()
    }
    return response
}

export const deleteFile = async (id) => {
    const {data} = await $api.delete('api/files/' + id)
    return data
}